import { useState } from "react";
import { Page } from "../components/ui.jsx";
import { CULTURE } from "../data/culture.js";

export default function Culture({ back }) {
  const [openCode, setOpenCode] = useState(null);
  const [openPillar, setOpenPillar] = useState(null);

  const pillar = CULTURE.pillars.find((p) => p.name === openPillar);

  return (
    <Page
      back={back}
      eyebrow="Who We Are"
      title="Culture Codes."
      intro="You don't learn a culture by reading it. You catch it. It's the rhythm, the honor, the fire, the flow. This is how we move."
    >
      <div className="vision-block">
        <div className="vlabel">The Vision</div>
        <div className="vtext">{CULTURE.vision}</div>
        <div className="vlabel" style={{ marginTop: 20 }}>
          The Mission
        </div>
        <div className="mtext">“{CULTURE.mission}”</div>
        <div className="vlabel" style={{ marginTop: 20 }}>
          Planted
        </div>
        <div className="mtext" style={{ fontSize: 14 }}>
          “{CULTURE.verse.text}” — {CULTURE.verse.ref}
        </div>
      </div>

      <div className="block">
        <h3>The mission, broken down</h3>
        {CULTURE.missionBreakdown.map((m) => (
          <p key={m.h}>
            <b>“{m.h}”</b> — {m.p}
          </p>
        ))}
      </div>

      <div className="block">
        <h3>Pillars of the house</h3>
        <p>Tap a pillar to open it up.</p>
        <div className="pillars">
          {CULTURE.pillars.map((p) => (
            <button
              key={p.name}
              className={"pillar pillar-btn" + (openPillar === p.name ? " on" : "")}
              onClick={() => setOpenPillar(openPillar === p.name ? null : p.name)}
              aria-expanded={openPillar === p.name}
            >
              {p.icon} {p.name}
            </button>
          ))}
        </div>
        {pillar && (
          <div className="pillar-def">
            <div className="pdh">
              {pillar.icon} {pillar.name}
            </div>
            <p>{pillar.def}</p>
          </div>
        )}
      </div>

      <div className="block">
        <h3>The lifestyle of partnership</h3>
        <p>
          <b>Pray. Serve. Give.</b> {CULTURE.partnership}
        </p>
      </div>

      <div className="block">
        <h3>The blueprint · {CULTURE.anchorRef}</h3>
        <p>{CULTURE.anchorNote}</p>
      </div>

      <div className="block">
        <h3>The 2026 Culture Codes</h3>
        <p>Fourteen codes. What we double down on. Tap any code to open it.</p>
      </div>

      {CULTURE.codes.map((c) => (
        <button
          key={c.n}
          className="codecard"
          onClick={() => setOpenCode(openCode === c.n ? null : c.n)}
          aria-expanded={openCode === c.n}
        >
          <div className="chead">
            <span className="cnum">{String(c.n).padStart(2, "0")}</span>
            <span className="cname">{c.name}</span>
          </div>
          {openCode === c.n && (
            <div className="cbody">
              {c.subs.length > 0 && (
                <ul>
                  {c.subs.map((s) => (
                    <li key={s}>{s}</li>
                  ))}
                </ul>
              )}
              <div className="cline">{c.line}</div>
            </div>
          )}
        </button>
      ))}
    </Page>
  );
}
